module.exports = __webpack_public_path__ + "img/KyowaKIRIN-background.d956ff62.png";